import { useQuery } from '@tanstack/react-query';
import { fetchAgreementFinancials } from '../services/agreementFinancials';
import { agreementKeys } from './agreementKeys';

export function useAgreementFinancialsQuery(id: string | undefined, enabled: boolean) {
    return useQuery({
        queryKey: agreementKeys.financials(id ?? ''),
        queryFn: () => fetchAgreementFinancials(id!),
        enabled: !!id && enabled,
        staleTime: 0,
        refetchOnWindowFocus: false,
    });
}
